/**
 * Global wishlist toggle for homepage Product + Related Products.
 * Click only (no pointerdown preventDefault — that broke some mobile browsers).
 * Card overlay link uses pointer-events:none in product-wishlist.css.
 */
if (!window.__freniWishlistDelegate) {
  window.__freniWishlistDelegate = true;

  const toggleWishlist = (el) => {
    const pressed = el.getAttribute('aria-pressed') === 'true';
    el.setAttribute('aria-pressed', pressed ? 'false' : 'true');
  };

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const control = target.closest('.product-wishlist');
      if (!control) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      toggleWishlist(control);
    },
    true
  );
}

window.__freniWishlistEnsure = function __freniWishlistEnsure(root) {
  const scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('.product-wishlist').forEach((el) => {
    if (!el.hasAttribute('aria-pressed')) {
      el.setAttribute('aria-pressed', 'false');
    }
  });
};
